module.exports = {}



// WEBPACK FOOTER //
// ./src/lang/i18nEN.js